import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { MarketingLayout } from "@/components/marketing/MarketingLayout";
import { PageHero, SectionHeading } from "@/components/marketing/primitives";
import { AnimatedWalkthrough } from "@/components/marketing/AnimatedWalkthrough";
import { PRODUCT_WALKTHROUGHS } from "@/components/marketing/walkthroughContent";

export default function Tour() {
  return <MarketingLayout>
    <PageHero eyebrow="Product tour" title="A closer look" accent="inside TenX."
      subtitle="Explore the real founder workspace and investor portal, using a demo company and sample data." />
    <section className="border-y border-slate-200 bg-white">
      <div className="mx-auto max-w-7xl px-5 py-12 sm:px-8 sm:py-16"><AnimatedWalkthrough idPrefix="full-tour" /></div>
    </section>
    <section className="mx-auto max-w-7xl px-5 py-12 sm:px-8 sm:py-16">
      <SectionHeading eyebrow="Keep exploring" title="Your next workflow starts here." id="tour-explore" />
      <div className="mt-6 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {Object.entries(PRODUCT_WALKTHROUGHS).map(([key, value]) => <Link key={key} to={`/product/${key}`} className="ff-manrope flex items-center justify-between gap-3 rounded-lg border border-slate-300 bg-white px-5 py-4 font-semibold text-neutral-900 transition-colors hover:border-brand hover:text-brand-ink" data-testid={`tour-explore-${key}`}>Explore {value.label}<ArrowRight className="h-4 w-4" /></Link>)}
      </div>
      <div className="mt-12 flex flex-wrap items-center justify-between gap-6 border-t border-slate-300 pt-8">
        <h2 className="ff-serif text-2xl font-medium text-neutral-900" data-testid="tour-start-heading">Make it your workspace.</h2>
        <Button asChild className="mk-button mk-button-orange" data-testid="tour-cta"><Link to="/register">Start free<ArrowRight className="h-4 w-4" /></Link></Button>
      </div>
    </section>
  </MarketingLayout>;
}